import type { Nullable } from '@/types'

export class TmBaseError<T extends Record<any, any> = Record<any, any>> extends Error {
  public name = 'BaseError'

  protected isMonitored = true

  protected isNotified = true

  protected data: T

  constructor(msg?: string, data?: T, stack?: string, cause?: unknown) {
    super(msg, { cause })
    if (stack) {
      this.stack = stack
    }
    this.setData(data || ({} as T))

    if (cause !== undefined && this.cause === undefined) {
      Object.defineProperty(this, 'cause', { value: cause, configurable: true, writable: true })
    }
  }

  public setData(data: T) {
    this.data = data
  }

  public getData() {
    return this.data
  }

  public static is(err: Error): err is TmBaseError {
    return !!(err as any).getData
  }

  public shouldBeMonitored(): boolean {
    return this.isMonitored
  }

  public shouldBeNotified(): boolean {
    return this.isNotified
  }

  public getSentryFingerprint(): Nullable<string[]> {
    return null
  }
}
